function animationGsapParallax() {
    const selectAll = e => document.querySelectorAll(e);
  
    const panels = selectAll(".gsap-parallax")

	// Verifica si los elementos requeridos existen en la página
	if (!panels) {
		return;
	}

    panels.forEach((panel, i) => {
      let imageWrappers = panel.querySelectorAll(".gsap-parallax-image img")
      
      gsap.fromTo(imageWrappers, {
        y: "-10vh",
        scale: 1.2,
      }, {
        y: "10vh",
        scrollTrigger: {
          trigger: panel,
          scrub: true,
          start: "top bottom", // position of trigger meets the scroller position
        },
        ease: 'none'
      })
    })
}
  
function initparallax() {
    animationGsapParallax();
}

window.onload = () => initparallax()
